var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex flex-row align-items-center mb-2 mt-2" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-primary mr-1",
              on: {
                click: function($event) {
                  return _vm.$refs.registerModal.open()
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "visitorManagement.cockpit.directRegistration.create"
                    )
                  ) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("DateRangePicker", {
            staticClass: "w-100",
            staticStyle: { "max-width": "18em" },
            attrs: {
              localeData: _vm.dateRangePickerLocale,
              timePicker: true,
              timePicker24Hour: true,
              showWeekNumbers: true,
              showDropdowns: true,
              autoApply: true,
              ranges: false,
              opens: "right"
            },
            on: { update: _vm.onDateRangeUpdated },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function(picker) {
                    return [
                      _vm._t(
                        "datePickerText",
                        function() {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  picker.startDate
                                    ? _vm.formatDateTime(picker.startDate)
                                    : _vm.$t("generalAlways")
                                ) +
                                " -\n            " +
                                _vm._s(
                                  picker.endDate
                                    ? _vm.formatDateTime(picker.endDate)
                                    : _vm.$t("generalAlways")
                                ) +
                                "\n          "
                            )
                          ]
                        },
                        { startDate: picker.startDate, endDate: picker.endDate }
                      )
                    ]
                  }
                }
              ],
              null,
              true
            ),
            model: {
              value: _vm.dateRange,
              callback: function($$v) {
                _vm.dateRange = $$v
              },
              expression: "dateRange"
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary ml-1",
              on: { click: _vm.selectLast3Months }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("visitorManagement.cockpit.selectLast3Months")
                  ) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "badge badge-secondary ml-auto" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("visitorManagement.cockpit.visitorsToday")) +
                ": " +
                _vm._s(_vm.visitorsToday)
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "badge ml-1",
              class: {
                "badge-warning": _vm.checkedInCount > 0,
                "badge-secondary": _vm.checkedInCount === 0
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("visitorManagement.cockpit.visitorsCheckedIn")
                  ) +
                  ": " +
                  _vm._s(_vm.checkedInCount) +
                  "\n      "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions,
          sortOptions: _vm.sortOptions,
          mode: "remote",
          rows: _vm.vgtManager.results.data,
          totalRows: _vm.vgtManager.results.totalRows,
          isLoading: _vm.loading || _vm.vgtManager.isLoading
        },
        on: {
          "on-page-change": function($event) {
            _vm.vgtManager.pageEvent.bind(_vm.vgtManager)($event)
          },
          "on-sort-change": function($event) {
            _vm.vgtManager.sortEvent.bind(_vm.vgtManager)($event)
          },
          "on-column-filter": function($event) {
            _vm.vgtManager.filterEvent.bind(_vm.vgtManager)($event)
          },
          "on-per-page-change": function($event) {
            _vm.vgtManager.perPageEvent.bind(_vm.vgtManager)($event)
          },
          "on-search": function($event) {
            _vm.vgtManager.searchEvent.bind(_vm.vgtManager)($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.isActions
                  ? _c(
                      "div",
                      { staticClass: "btn-group" },
                      [
                        _c("PresenceStartStopButton", {
                          attrs: {
                            groupSurveyExtensionId:
                              props.row.groupSurveyExtensionId,
                            presenceId: props.row.presenceId,
                            userId: props.row.userId,
                            externalUserId: props.row.externalUserId,
                            checkedIn:
                              props.row.presenceId && !props.row.checkedOut
                          },
                          on: {
                            started: _vm.onPresenceChanged,
                            stopped: _vm.onPresenceChanged
                          }
                        }),
                        _vm._v(" "),
                        _c("PrintBadgeButton", {
                          attrs: {
                            groupSurveyExtensionId:
                              props.row.groupSurveyExtensionId,
                            groupUserExternalId: props.row.externalUserId
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-secondary",
                            attrs: {
                              title: _vm.$t(
                                "visitorManagement.cockpit.tooltip.visitDetails"
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.openGroupDetailsModal(
                                  props.row.groupSurveyExtensionId
                                )
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-info-circle" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "visible",
                                rawName: "v-visible",
                                value: props.row.externalUserId,
                                expression: "props.row.externalUserId"
                              }
                            ],
                            staticClass: "btn btn-sm btn-info",
                            attrs: {
                              title: _vm.$t(
                                "visitorManagement.cockpit.tooltip.userPicture"
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.openGroupUserPictureModal(
                                  props.row.groupSurveyExtensionId,
                                  props.row.externalUserId
                                )
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-image" })]
                        )
                      ],
                      1
                    )
                  : props.column.type === "boolean" &&
                    props.formattedRow[props.column.field]
                  ? _c("span", { staticClass: "badge badge-success" }, [
                      _c("i", { staticClass: "fa fa-check mr-1" }),
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("yes")) + "\n        "
                      )
                    ])
                  : props.column.type === "boolean"
                  ? _c("span", { staticClass: "badge badge-danger" }, [
                      _c("i", { staticClass: "fa fa-times mr-1" }),
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("no")) + "\n        "
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n        "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("GroupsForSurveyEditModal", {
        ref: "detailsModal",
        attrs: {
          groups: _vm.cockpitReferencedGroups,
          allUsers: _vm.users,
          availableSalutations: _vm.availableSalutations,
          groupSaveFunction: g => _vm.saveGroup(g),
          allowNoEmailForExternalUsers: true
        }
      }),
      _vm._v(" "),
      _c("DirectRegistrationModal", {
        ref: "registerModal",
        attrs: {
          allUsers: _vm.users,
          availableSalutations: _vm.availableSalutations,
          groupSaveFunction: g => _vm.saveGroup(g)
        },
        on: { saved: _vm.reload }
      }),
      _vm._v(" "),
      _c("PictureModal", { ref: "pictureModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }